import { useState } from 'react';
import { Link } from 'react-router-dom';
import './About.css';

import splitImg from '../assets/about/split.jpg';
import heroAbout from '../assets/about/hero-construction-1.jpg';
import collageTop from '../assets/about/collage-top.jpg';
import collageBl from '../assets/about/collage-bl.jpg';
import collageBr from '../assets/about/collage-br.jpg';
import valueQualityImg from '../assets/about/value-quality.jpg';
import founderPhoto from '../assets/about/pranjualMishraAbout.jpeg';
import teamPranjul from '../assets/about/ourteamPranjul.jpeg';
import teamSatyam from '../assets/about/SatyamVp.jpeg';

import CallbackModal from '../components/CallbackModal';
import CountUpValue from '../components/CountUpValue';

const teamMembers = [
  { name: 'Pranjul Mishra', role: 'Founder & Consultant', photo: teamPranjul },
  { name: 'Satyam Prakhar', role: 'Vice President', photo: teamSatyam },
];

const TEAM_EMAIL = 'info@landmarksconstruction.in';
const TEAM_LINKEDIN = 'https://linkedin.com';

function IconLinkedIn({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden>
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  );
}

function IconMail({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden>
      <path
        d="M4 6h16v12H4V6zm0 0l8 6 8-6"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconTeamWorksCheck() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.75" />
      <path
        d="M8 12l2.5 2.5L16 9"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconWhyMonitor() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden>
      <rect x="3" y="4" width="18" height="12" rx="2" stroke="currentColor" strokeWidth="1.75" />
      <path d="M8 20h8M12 16v4" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  );
}

function IconWhyShield() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden>
      <path
        d="M12 3l7 4v6c0 5-3.5 9-7 10-3.5-1-7-5-7-10V7l7-4z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path
        d="M9 12l2 2 4-4"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconWhyIsoCheck() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.75" />
      <path
        d="M8 12l2.5 2.5L16 9"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconFounderBook() {
  return (
    <span className="about-founder-card-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
        <path
          d="M4 19.5A2.5 2.5 0 016.5 17H20M4 19.5A2.5 2.5 0 016.5 22H20V2H6.5A2.5 2.5 0 004 4.5v15zM6.5 2H20v15H6.5A2.5 2.5 0 014 15.5V4.5A2.5 2.5 0 016.5 2z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}

function IconFounderPeople() {
  return (
    <span className="about-founder-card-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
        <path
          d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}

function IconFounderBulb() {
  return (
    <span className="about-founder-card-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
        <path
          d="M9 18h6M10 22h4M12 2a7 7 0 017 7c0 3-2 5-3 6v1H8v-1c-1-1-3-3-3-6a7 7 0 017-7z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}

const heroStatCards = [
  {
    value: '120+',
    label: 'Projects completed',
    tone: 'sky',
    Icon: IconStatUsers,
  },
  {
    value: '5+',
    label: 'Years experience',
    tone: 'violet',
    Icon: IconStatAward,
  },
  {
    value: '1.2+',
    suffix: 'M',
    label: 'Sq. ft. built',
    tone: 'orange',
    Icon: IconStatBuilding,
  },
  {
    value: '200+',
    label: 'Designs delivered',
    tone: 'emerald',
    Icon: IconStatChart,
  },
];

function IconStatUsers({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden>
      <path
        d="M16 11a4 4 0 10-8 0 4 4 0 008 0zM4 20v-1a6 6 0 0112 0v1M20 20v-1a4 4 0 00-4-4"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  );
}

function IconStatAward({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden>
      <path
        d="M8.5 8.5h7L12 4 8.5 8.5zM6 10l1.5 8L12 15l4.5 3L18 10M8.5 8.5L6 10M15.5 8.5L18 10"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconStatBuilding({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden>
      <path
        d="M4 21V8l8-4v17M12 4l8 4v13M9 13v3M9 17v2M15 13v3M15 17v2"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconStatChart({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden>
      <path d="M4 20V10M10 20V4M16 20v-6M22 20V8" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  );
}

export default function About() {
  const [callbackOpen, setCallbackOpen] = useState(false);

  return (
    <div className="about-page">
      <CallbackModal open={callbackOpen} onClose={() => setCallbackOpen(false)} />

      <section className="about-hero-pro" aria-labelledby="about-hero-title">
        <div className="about-hero-pro-bg">
          <img
            src={heroAbout}
            alt=""
            className="about-hero-pro-photo"
            decoding="async"
          />
          <div className="about-hero-pro-gradient" aria-hidden="true" />
          <div className="about-hero-pro-orbs" aria-hidden="true" />
          <div className="about-hero-pro-grid" aria-hidden="true" />
          <div className="about-hero-pro-stars" aria-hidden="true" />
        </div>

        <div className="about-hero-pro-inner">
          <div className="about-container about-hero-pro-layout">
            <div className="about-hero-pro-copy">
              <h1 id="about-hero-title" className="about-hero-pro-title">
                <span className="about-hero-pro-title-plain">About</span>{' '}
                <span className="about-hero-pro-title-brand">Landmarks</span>{' '}
                <span className="about-hero-pro-title-plain">Construction</span>
              </h1>
              <p className="about-hero-pro-lead">
                Construction consulting and delivery that keeps your scope, budget, and timeline aligned—from
                first drawings to handover in Delhi NCR.
              </p>
              <div className="about-hero-pro-actions">
                <button type="button" className="about-hero-pro-btn about-hero-pro-btn--primary" onClick={() => setCallbackOpen(true)}>
                  Request a callback
                </button>
                <Link to="/services" className="about-hero-pro-btn about-hero-pro-btn--ghost">
                  Explore services
                </Link>
              </div>
            </div>

            <ul className="about-hero-pro-stats" aria-label="Key figures">
              {heroStatCards.map(({ value, suffix, label, tone, Icon }) => (
                <li key={label} className={`about-hero-pro-stat about-hero-pro-stat--${tone}`}>
                  <span className="about-hero-pro-stat-icon" aria-hidden="true">
                    <Icon />
                  </span>
                  <p className="about-hero-pro-stat-value">
                    <CountUpValue value={value} />
                    {suffix ? <span className="about-hero-pro-stat-suffix">{suffix}</span> : null}
                  </p>
                  <p className="about-hero-pro-stat-label">{label}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="about-hero-pro-wave" aria-hidden="true">
          <svg viewBox="0 0 1440 120" preserveAspectRatio="none" className="about-hero-pro-wave-svg">
            <defs>
              <linearGradient id="about-hero-wave-fill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#ede8fa" />
                <stop offset="55%" stopColor="#f7f5ff" />
                <stop offset="100%" stopColor="#f7f5ff" />
              </linearGradient>
            </defs>
            <path
              fill="url(#about-hero-wave-fill)"
              d="M0,80 C180,40 360,100 540,70 C720,40 900,90 1080,65 C1260,40 1380,55 1440,50 L1440,120 L0,120 Z"
            />
          </svg>
        </div>

        <div className="about-hero-pro-scroll" aria-hidden="true">
          <span className="about-hero-pro-mouse">
            <span className="about-hero-pro-wheel" />
          </span>
        </div>
      </section>

      <section className="about-split-section">
        <div className="about-container about-split-row">
          <div className="about-split-copy">
            <p className="about-split-kicker">Are you searching for the</p>
            <h2 className="about-split-headline">
              &ldquo;Best construction partner near me?&rdquo;
            </h2>
            <div className="about-split-prose">
              <p>
                In a crowded market of contractors, clients choose Landmarks Construction for clear
                communication, disciplined site management, and finishes that hold up over time. We
                work with moderate to premium budgets—always with the same focus on safety, code, and
                schedule.
              </p>
              <p>
                Founded in Noida, we serve homeowners, investors, and businesses across Delhi NCR.
                From structural shells to turnkey interiors, our teams coordinate civil, MEP, and
                finishing trades so you are not juggling dozens of vendors alone.
              </p>
              <p>
                Whether it is a new villa, a commercial floor, or a full renovation, we expand our
                role from pure execution to design coordination, approvals support, and long-term
                maintainability—so the building works as well as it looks.
              </p>
            </div>
          </div>
          <div className="about-split-media">
            <img
              src={splitImg}
              alt="Construction planning and teamwork at site"
              className="about-split-img"
            />
          </div>
        </div>
      </section>

      <section className="about-experience-section">
        <div className="about-container about-exp-row">
          <div className="about-exp-visual">
            <div className="about-collage" aria-hidden="true">
              <img src={collageTop} alt="" className="about-collage-img about-collage-img--top" />
              <img src={collageBl} alt="" className="about-collage-img about-collage-img--bl" />
              <img src={collageBr} alt="" className="about-collage-img about-collage-img--br" />
            </div>
          </div>
          <div className="about-exp-copy">
            <div className="about-exp-heading-block">
              <span className="about-exp-number">5+</span>
              <h2 className="about-exp-heading">
                Years of
                <br />
                working experience
              </h2>
            </div>
            <div className="about-exp-prose">
              <p>
                <span className="about-exp-brand">Landmarks Construction</span>, rooted in Noida,
                is a trusted name in residential and commercial building across Delhi NCR. We
                provide architectural coordination, turnkey execution, and interior packages for
                homes and workplaces—with civil engineers and designers focused on quality,
                timelines, and transparent communication.
              </p>
              <p>
                Over the years we have delivered villas, floors, offices, and renovations with the
                same disciplined approach: clear drawings, documented changes, and site safety every
                day.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-value-section">
        <div className="about-container about-value-row">
          <div className="about-value-copy">
            <p className="about-value-kicker">Value for money concept</p>
            <h2 className="about-value-headline">Right quality in right time</h2>
            <div className="about-value-prose">
              <p>
                We finish milestones on committed dates and stand behind workmanship. Our processes
                follow approved construction standards and safety norms prescribed by authorities—so
                every stage is documented and accountable.
              </p>
              <p>
                Our vision is to grow across Delhi NCR and beyond while keeping the Landmarks
                promise: ethical dealing, clear contracts, and builds you can rely on for decades.
              </p>
              <p>
                We do not just pour concrete—we manage the full lifecycle from understanding your
                brief to handover, so premium and mid-budget clients alike get the same care.
              </p>
            </div>
          </div>
          <div className="about-value-visual">
            <img
              src={valueQualityImg}
              alt="Quality construction workmanship"
              className="about-value-img"
            />
            <div className="about-seal about-seal--a" aria-hidden="true">
              <span className="about-seal-ring">Best quality guaranteed</span>
              <span className="about-seal-core">✓</span>
            </div>
            <div className="about-seal about-seal--b" aria-hidden="true">
              <span className="about-seal-ring">On-time delivery</span>
              <span className="about-seal-core">✓</span>
            </div>
          </div>
        </div>
      </section>

      <section className="about-founder-section" aria-labelledby="about-founder-heading">
        <div className="about-container about-founder-wrap">
          <header className="about-founder-header">
            <p className="about-founder-eyebrow">Meet the Founder</p>
            <h2 id="about-founder-heading" className="about-founder-title">
              Construction leadership at Landmarks Construction
            </h2>
          </header>

          <div className="about-founder-top">
            <div className="about-founder-visual-col">
              <div className="about-founder-photo-card">
                <div className="about-founder-photo-frame">
                  <img
                    src={founderPhoto}
                    alt="Pranjul Mishra"
                    className="about-founder-photo-img"
                    decoding="async"
                  />
                  <div className="about-founder-photo-overlay">
                    <span className="about-founder-overlay-name">Pranjul Mishra</span>
                    <span className="about-founder-overlay-role">Founder &amp; Consultant</span>
                  </div>
                </div>
              </div>
              <blockquote className="about-founder-quote-box">
                <span className="about-founder-quote-mark" aria-hidden="true">
                  &ldquo;
                </span>
                <p>
                  Build quality shapes how people live and work—not just square footage.
                </p>
              </blockquote>
            </div>

            <div className="about-founder-copy-col">
              <article className="about-founder-card about-founder-card--intro">
                <div className="about-founder-intro-head">
                  <span className="about-founder-intro-accent" aria-hidden="true" />
                  <div className="about-founder-intro-titles">
                    <h3 className="about-founder-card-name">Pranjul Mishra</h3>
                    <p className="about-founder-card-tagline">
                      Build quality shapes how people live and work—not just square footage.
                    </p>
                  </div>
                </div>
                <p className="about-founder-card-text">
                  Mr. Pranjul Mishra is a construction entrepreneur and consultant, guiding homeowners and
                  investors across <strong>Noida and Delhi NCR</strong>. With years of field experience, he
                  leads <strong>Landmarks Construction</strong>, focused on disciplined execution,
                  transparent costing, and long-term build quality.
                </p>
              </article>

              <article className="about-founder-card">
                <h4 className="about-founder-card-heading">
                  <IconFounderBook />
                  The Journey
                </h4>
                <p className="about-founder-card-text">
                  He entered the industry with a strong academic foundation, including an{' '}
                  <strong>MBA from Integral University, Lucknow</strong>. Early in his career he worked
                  closely with developers, contractors, and end clients, gaining practical insight into
                  residential and commercial delivery.
                </p>
                <p className="about-founder-card-text">
                  His approach has always centred on{' '}
                  <strong>analysis and disciplined decision-making</strong> rather than cutting corners on
                  site.
                </p>
              </article>
            </div>
          </div>

          <div className="about-founder-mid-grid">
            <article className="about-founder-card">
              <h4 className="about-founder-card-heading">
                <IconFounderPeople />
                Experience &amp; Impact
              </h4>
              <p className="about-founder-card-text">
                Over the years, Pranjul has advised{' '}
                <strong className="about-founder-highlight">more than 200 families and investors</strong>
                , helping them navigate construction and project delivery with confidence. He has built
                trusted relationships with consultants and execution partners across Noida and is known for
                structured guidance supported by site discipline and documentation.
              </p>
            </article>
            <article className="about-founder-card">
              <h4 className="about-founder-card-heading">
                <IconFounderBulb />
                The Vision
              </h4>
              <p className="about-founder-card-text">
                With the belief that{' '}
                <strong className="about-founder-highlight">
                  &ldquo;build quality shapes lasting value&rdquo;
                </strong>
                , Pranjul founded Landmarks Construction in{' '}
                <strong className="about-founder-highlight">January 2022</strong> to offer a more thoughtful
                alternative to fragmented contracting.
              </p>
              <p className="about-founder-card-text">
                His work focuses on simplifying coordination, reducing risk on site, and helping clients
                move forward with confidence—from drawings to handover.
              </p>
            </article>
          </div>

          <article className="about-founder-card about-founder-card--full">
            <p className="about-founder-card-text about-founder-card-text--solo">
              Outside of client work, Pranjul remains deeply engaged in studying materials, methods,
              investment trends, and the evolving construction landscape in NCR. He is motivated by the
              moment clients secure a home or workspace they truly believe in—knowing the decision was made
              with purpose and delivered with care.
            </p>
          </article>

          <ul className="about-founder-stats" aria-label="Founder highlights">
            <li className="about-founder-stat">
              <span className="about-founder-stat-value">200+</span>
              <span className="about-founder-stat-label">Families advised</span>
            </li>
            <li className="about-founder-stat">
              <span className="about-founder-stat-value">2022</span>
              <span className="about-founder-stat-label">Company founded</span>
            </li>
            <li className="about-founder-stat">
              <span className="about-founder-stat-value">MBA</span>
              <span className="about-founder-stat-label">Integral University</span>
            </li>
            <li className="about-founder-stat">
              <span className="about-founder-stat-value">NCR</span>
              <span className="about-founder-stat-label">Service region</span>
            </li>
          </ul>
        </div>
      </section>

      <section className="about-team-works-section" aria-labelledby="about-team-works-heading">
        <div className="about-container about-team-works-inner">
          <h2 id="about-team-works-heading" className="about-team-works-title">
            How Landmarks{' '}
            <span className="about-team-works-title-mark">Construction</span> Team Works
          </h2>
          <article className="about-team-works-card">
            <div className="about-team-works-card-icon" aria-hidden="true">
              <IconTeamWorksCheck />
            </div>
            <div className="about-team-works-card-body">
              <p>
                At Landmarks Construction, building is treated as a{' '}
                <strong className="about-team-works-em">
                  serious delivery decision, not a sales pitch.
                </strong>{' '}
                We support residential owners, commercial clients, and portfolio investors with execution-led
                services that reduce risk and remove guesswork on site.
              </p>
              <p>
                Our team covers residential execution, commercial build-outs, planning and BOQ, compliance
                liaison, and on-site quality control. Each engagement is handled with{' '}
                <strong className="about-team-works-em">focus, discretion, and accountability.</strong>
              </p>
              <p>
                Clients trust us because we stay objective.{' '}
                <strong className="about-team-works-em">Your interests always come first.</strong>
              </p>
            </div>
          </article>
        </div>
      </section>

      <section className="about-meet-team-section" aria-labelledby="about-meet-team-heading">
        <div className="about-container">
          <header className="about-meet-team-header">
            <h2 id="about-meet-team-heading" className="about-meet-team-title">
              Our Team
            </h2>
            <p className="about-meet-team-sub">
              Dedicated professionals committed to your construction success
            </p>
          </header>
          <ul className="about-meet-team-grid">
            {teamMembers.map(({ name, role, photo }) => (
              <li key={name} className="about-meet-team-card">
                <div className="about-meet-team-photo-wrap">
                  <img src={photo} alt="" className="about-meet-team-photo" decoding="async" />
                </div>
                <h3 className="about-meet-team-name">{name}</h3>
                <p className="about-meet-team-role">{role}</p>
                <div className="about-meet-team-social">
                  <a
                    href={TEAM_LINKEDIN}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="about-meet-team-social-link"
                    aria-label={`${name} on LinkedIn`}
                  >
                    <IconLinkedIn />
                  </a>
                  <a
                    href={`mailto:${TEAM_EMAIL}?subject=${encodeURIComponent(`Enquiry regarding ${name}`)}`}
                    className="about-meet-team-social-link"
                    aria-label={`Email regarding ${name}`}
                  >
                    <IconMail />
                  </a>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="about-why-section" aria-labelledby="about-why-heading">
        <div className="about-container about-why-inner">
          <h2 id="about-why-heading" className="about-why-title">
            Why Landmarks Construction Is the <span className="about-why-title-mark">Smart Choice</span> for
            Your Build
          </h2>
          <div className="about-why-intro-card">
            <p className="about-why-intro-text">
              Landmarks Construction blends{' '}
              <strong className="about-why-em">sharp technical insight</strong> with hands-on site
              experience to help owners and investors spot solid opportunities and avoid costly missteps.
              With a focus on programme, cost, and long-term value, the team treats every project like a{' '}
              <strong className="about-why-em">
                serious business decision, not as a transaction.
              </strong>
            </p>
          </div>
          <div className="about-why-grid">
            <article className="about-why-card about-why-card--blue">
              <span className="about-why-card-accent" aria-hidden="true" />
              <div className="about-why-card-icon about-why-card-icon--blue">
                <IconWhyMonitor />
              </div>
              <h3 className="about-why-card-title">Smart tech at work</h3>
              <p className="about-why-card-text">
                Virtual meetings, digital drawings and approvals, and fast site updates let you cover more
                ground with less effort. Timely data on progress, costs, and dependencies helps you release
                milestones at the right moment.
              </p>
            </article>
            <article className="about-why-card about-why-card--violet">
              <span className="about-why-card-accent" aria-hidden="true" />
              <div className="about-why-card-icon about-why-card-icon--violet">
                <IconWhyShield />
              </div>
              <h3 className="about-why-card-title">RERA-approved</h3>
              <p className="about-why-card-text">
                Landmarks Construction focuses on RERA-aligned projects where applicable, giving you clear
                visibility on approvals, delivery timelines, and commitments. That framework increases
                buyer safety and keeps execution transparent and accountable.
              </p>
            </article>
            <article className="about-why-card about-why-card--green">
              <span className="about-why-card-accent" aria-hidden="true" />
              <div className="about-why-card-icon about-why-card-icon--green">
                <IconWhyIsoCheck />
              </div>
              <h3 className="about-why-card-title">ISO-certified</h3>
              <p className="about-why-card-text">
                ISO-based systems keep our service, documentation, and follow-ups organised and consistent.
                You gain reliable quality, professional handling, and a team dedicated to high standards
                every single day.
              </p>
            </article>
          </div>
        </div>
      </section>

      <section className="about-lmc-banner">
        <div className="about-container">
          <p className="about-lmc-text">We undertake labour &amp; material contract</p>
        </div>
      </section>
    </div>
  );
}
